export default __webpack_public_path__ + "static/media/cardbg.763a88af.jpeg";